// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f8f9fa;
}

.outputs {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: center;
  padding: 20px 40px 10px 40px;
  overflow: hidden;
}

.output-column-single {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
  max-width: 65%;
}

.controls-bar {
  padding: 20px 40px 0 40px;
  width: 100%;
  box-sizing: border-box;
}

.controls-bar-bottom {
  padding: 0 40px 20px 40px;
  width: 100%;
  box-sizing: border-box;
  background-color: #f8f9fa; /* Ensure it matches container background */
}

.model-selector-container {
  display: flex;
  gap: 20px;
  width: 100%;
}

.model-selector {
  flex: 1 1;
}

.model-selector select {
  width: 100%;
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  height: 42px;
  box-sizing: border-box;
}

.input-column {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.input-form {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 10px;
}

.input-wrapper {
  position: relative;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.large-input {
  flex: 1 1;
  padding: 15px;
  /* padding-bottom removed since button is moved out */
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: none;
  font-family: inherit;
}

.submit-button {
  position: absolute;
  bottom: 10px;
  right: 10px;
  padding: 8px 16px;
  font-size: 14px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  z-index: 10;
}

.submit-button:hover:not(:disabled) {
  background-color: #0056b3;
}

.submit-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.submit-button-aligned {
  padding: 10px 24px;
  font-size: 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.submit-button-aligned:hover:not(:disabled) {
  background-color: #0056b3;
}

.submit-button-aligned:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.model-controls-bottom {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.model-controls-bottom select {
  flex: 1 1; /* Allow it to grow but constrained by column */
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  height: 42px;
  box-sizing: border-box;
}

/* Cleanup unused styles */
.controls-bar-bottom {
  display: none;
}


.model-dropdown {
  flex: 1 1;
  min-width: 0;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 32px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.modal-content h2 {
  margin: 0 0 20px 0;
  font-size: 20px;
  color: #212529;
}

.modal-input {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.modal-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.modal-button {
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ccc;
  transition: background-color 0.2s;
}

.modal-button.submit {
  background-color: #007bff;
  color: white;
  border: none;
}

.modal-button.submit:hover {
  background-color: #0056b3;
}

.modal-button.cancel {
  background-color: white;
  color: #212529;
}

.modal-button.cancel:hover {
  background-color: #f8f9fa;
}

.modal-button.logout {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.modal-button.logout:hover {
  background-color: #c82333;
}

.error-message {
  color: #dc3545;
  font-size: 1.1em;
  text-align: center;
  margin: 20px 0;
  padding: 10px;
  background-color: #fff5f5;
  border: 1px solid #ffcdd2;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,yBAAyB,EAAE,2CAA2C;AACxE;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qDAAqD;EACrD,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO,EAAE,+CAA+C;EACxD,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;AACf;;;AAGA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background-color: #f8f9fa;\n}\n\n.outputs {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  justify-content: center;\n  padding: 20px 40px 10px 40px;\n  overflow: hidden;\n}\n\n.output-column-single {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-height: 0;\n  max-width: 65%;\n}\n\n.controls-bar {\n  padding: 20px 40px 0 40px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.controls-bar-bottom {\n  padding: 0 40px 20px 40px;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: #f8f9fa; /* Ensure it matches container background */\n}\n\n.model-selector-container {\n  display: flex;\n  gap: 20px;\n  width: 100%;\n}\n\n.model-selector {\n  flex: 1;\n}\n\n.model-selector select {\n  width: 100%;\n  padding: 8px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: white;\n  height: 42px;\n  box-sizing: border-box;\n}\n\n.input-column {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.input-form {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  gap: 10px;\n}\n\n.input-wrapper {\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.large-input {\n  flex: 1;\n  padding: 15px;\n  /* padding-bottom removed since button is moved out */\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  resize: none;\n  font-family: inherit;\n}\n\n.submit-button {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  padding: 8px 16px;\n  font-size: 14px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  z-index: 10;\n}\n\n.submit-button:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.submit-button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.submit-button-aligned {\n  padding: 10px 24px;\n  font-size: 16px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.submit-button-aligned:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.submit-button-aligned:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.model-controls-bottom {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.model-controls-bottom select {\n  flex: 1; /* Allow it to grow but constrained by column */\n  padding: 8px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: white;\n  height: 42px;\n  box-sizing: border-box;\n}\n\n/* Cleanup unused styles */\n.controls-bar-bottom {\n  display: none;\n}\n\n\n.model-dropdown {\n  flex: 1;\n  min-width: 0;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  padding: 32px;\n  border-radius: 8px;\n  width: 400px;\n  max-width: 90%;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n}\n\n.modal-content h2 {\n  margin: 0 0 20px 0;\n  font-size: 20px;\n  color: #212529;\n}\n\n.modal-input {\n  width: 100%;\n  padding: 12px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  box-sizing: border-box;\n}\n\n.modal-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.modal-button {\n  padding: 8px 16px;\n  font-size: 14px;\n  border-radius: 4px;\n  cursor: pointer;\n  border: 1px solid #ccc;\n  transition: background-color 0.2s;\n}\n\n.modal-button.submit {\n  background-color: #007bff;\n  color: white;\n  border: none;\n}\n\n.modal-button.submit:hover {\n  background-color: #0056b3;\n}\n\n.modal-button.cancel {\n  background-color: white;\n  color: #212529;\n}\n\n.modal-button.cancel:hover {\n  background-color: #f8f9fa;\n}\n\n.modal-button.logout {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.modal-button.logout:hover {\n  background-color: #c82333;\n}\n\n.error-message {\n  color: #dc3545;\n  font-size: 1.1em;\n  text-align: center;\n  margin: 20px 0;\n  padding: 10px;\n  background-color: #fff5f5;\n  border: 1px solid #ffcdd2;\n  border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
